import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import * as translationEN from './en-US.json';
import * as translationPT from './pt-BR.json';
import * as translationES from './es-ES.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': { translation: translationEN },
      'pt-BR': { translation: translationPT },
      'es-ES': { translation: translationES },
    },
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;